<script lang="ts">
  import { Col, Progress, Row, Table } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import {
    DefaultProgress,
    DefaultProgressMessage,
    ProgressSizes,
    ProgressSizesMessage,
    StripedProgress,
    StripedProgressMessage,
  } from "../../../../utils/Constant/Constant";
</script>

<Col sm="12">
  <Card headerTitle={"Progressbar"}>
    <div slot="contentbody">
      <Row class="card-block">
        <Col sm="12" lg="12" xl="12">
          <div class="table-responsive">
            <Table bordered class="checkbox-td-width">
              <tbody>
                <tr>
                  <td>{DefaultProgress}</td>
                  <td class="w-50">
                    <Progress value={75} color="primary" />
                  </td>
                  <td><span>{@html DefaultProgressMessage}</span></td>
                </tr>
                <tr>
                  <td>{StripedProgress} </td>
                  <td>
                    <Progress striped value={75} color="primary" />
                  </td>
                  <td><span>{@html StripedProgressMessage}</span></td>
                </tr>
                <tr>
                  <td>{ProgressSizes}</td>
                  <td>
                    <Progress
                      class="lg-progress-bar"
                      value={75}
                      color="primary"
                    />
                  </td>
                  <td><span>{@html ProgressSizesMessage}</span></td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  </Card>
</Col>
